module.exports = __webpack_public_path__ + "static/img/game2.700fc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game2.png
// module id = Gwxc
// module chunks = 1